//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import SocietyFloat from '../societyFloat/societyFloat.vue'
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import { Toast } from 'vant'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import quoLoginModule from "@/pages/product/quoLoginModule"
import demandAddForm from '../modules/demandAddForm'
import supplyDemandAddForm from '../modules/supplyDemandAddForm'
export default {
  name: "societyIndex",
  data() {
    let that = this
    return {
      sw:null,
      userInfo: this.$store.getters.getUserInfo,
      value: "",
      indexR: 1, // 当前轮播图下方小点点选中第几个  从1 开始
      swiperOptionThumbsF: {
        autoplay: {
          disableOnInteraction: false,
          delay: 500,
        },
        observer:true,
        speed:500,
        pagination:'.swiper-pagination',
        paginationClickable: true,
        mousewheelControl: true,
        observeParents:true,
        loop: true,
        loopedSlides: 5,
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
		navigation: {
        	nextEl: '.swiper-button-next',
        	prevEl: '.swiper-button-prev',
        },
        on: {
          slideChange:(event) => {
            that.indexR = event.activeIndex % that.societyInfo.ccFileInfoList.length
          }
        },
      },
	  checkCompanyType : "-1",//当前选中的企业分类id
	  pageSizeSel: 9, //首页各项默认显示几条
	  companyTypeList: null ,//企业分类 list
	  companyInfoList: null ,//企业list
	  showMoreCompany: false,//是否显示查看更多企业按钮 true显示

	  userDemandList: null, //客户需求list
	  showMoreDemand: true,//是否显示查看更多需求按钮 true显示

	  societyArticleNewsList: null,//文章资讯list
	  societyArticleNewsListOne: [],// 显示到图文的两个
	  societyArticleNewsListTwo: [],// 显示文章资讯列表的
	  showMoreNews: true,//是否显示查看更多文章资讯按钮 true显示

	  djNewsList: null,//党建 文章资讯list
	  djNewsListTwo: [],//党建 文章资讯列表显示位置用
	  showMoreDjNews: true,//是否显示查看更多 党建 文章资讯按钮 true显示

      supplyDemandList: [],
      showMoreSupplyDemand: true, //是否显示查看更多需求按钮 true显示


	  societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId :  window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
	  societyName: (this.$route.query.societyName != null && this.$route.query.societyName != '' ) ? this.$route.query.societyName : window.localStorage.getItem('societyName'),
	  logoImgUrl: (this.$route.query.logoImgUrl != undefined && this.$route.query.logoImgUrl != null && this.$route.query.logoImgUrl != '' ) ? this.$route.query.logoImgUrl : window.localStorage.getItem('logoImgUrl'),
	  societyInfo: {},//机构信息
	  currentIndex: 0,  //当前选中的轮播图index
	  timer: null,
      allCompanyNum: 0 // 协会加入企业的数量
    }
  },
  activated () {
    this.userInfo = this.$store.getters.getUserInfo
  },
  directives: {
    swiper: directive
  },
  components: { Header, Footer, SocietyFloat, demandAddForm,supplyDemandAddForm,quoLoginModule,Swiper,SwiperSlide },
  computed: {
    text() {
      return {};
    },
    swiperF () {
      return this.$refs.swiperTopF.$swiper
    }
  },
  destroyed(){
      window.clearInterval(this.sw)
  },

  methods: {
	  //跳转至申请加入机构页面
	  fnGotoSignInSociety(e){
		this.fnStopBub(e);
			if (this.userInfo != null && this.userInfo != undefined && this.userInfo.id != null && this.userInfo.id != '' && this.userInfo.id != undefined) {
				//暂时跳转到：企业中心
				Toast("请去'企业中心->企业信息管理'中申请加入协会");
			}else{
				//暂时跳转到：企业中心
				Toast("请登录后，去'企业中心->企业信息管理'中申请加入协会");
			}
	  },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    showC(){
      window.clearInterval(this.sw)
    },
    showU(){
      window.clearInterval(this.sw)
      this.goto()
    },
    goto (){
      this.sw = setInterval(() => {this.swiperF.slideNext()},5000)
    },
    handleBtnBannerLeftClicked () {
     this.swiperF.slidePrev()
    },
    handleBtnBannerRightClicked () {
     this.swiperF.slideNext()
    },
      //初始化机构主数据
      fnInitData(){
        let that = this;
        let obj = new Object();
        obj.id = that.societyId;
        requestByPost(API.selSocietyInfoById,JSON.stringify(obj)).then((res)=>{
          if(res.data != undefined && res.data.obj != undefined && res.data.obj != null ){
            that.societyInfo = res.data.obj;
            that.$store.commit('home/setSocietyLogoUrl', res.data.obj.logoImgUrl);//机构菜单
			that.$store.commit('home/setSocietyPhone', res.data.obj.societyPhone);//机构电话
			// alert("赋值："+res.data.obj.societyPhone);
			this.societyPhone = res.data.obj.societyPhone
            that.logoImgUrl = res.data.obj.logoImgUrl;
          }else{
            that.$store.commit('home/setSocietyLogoUrl',null)
			that.$store.commit('home/setSocietyPhone', '');//机构电话
            that.logoImgUrl = null;
            that.societyInfo = {};
          }
        })
      },

      //切换企业分类
      showCompanyTypeTab(params,e){
        this.fnStopBub(e);
        this.checkCompanyType = params;
        this.fnLoadCompanyInfoList(2);

      },
      //根据条件查询 机构内符合条件的企业信息
      fnLoadCompanyInfoList(inType){
        let that = this;
        var selObj = new Object();
        let page = new Object();
        page.pageNum = 0;
        page.pageSize = that.pageSizeSel;
        selObj.page = page;
        selObj.companyType = that.checkCompanyType;
        selObj.societyId = that.societyId;
        requestByPost(API.selSocietyCompanyPageFormEsForHome,JSON.stringify(selObj)).then((res)=>{
          // console.log("协会主页查询的企业结果："+JSON.stringify(res));
          if(res.data.retCode == 1 && res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.obj.societyCompanyList != null &&  res.data.obj.societyCompanyList.length != 0){
            that.companyInfoList = res.data.obj.societyCompanyList;
            that.allCompanyNum = res.data.obj.page.total;
            if(that.companyInfoList.length == res.data.obj.page.total){
              that.showMoreCompany = false;
            }else{
              that.showMoreCompany = true;
            }
            if(inType == 1){
              that.companyTypeList = res.data.obj.companyTypeList;
            }
          }else{
            that.showMoreCompany = false;
            that.companyInfoList = null;
            if(inType == 1){
              that.companyTypeList = null;
            }
          }
        })
      },
      /* 加载客户需求list */
      fnLoadUserDemandList(){
        let that = this;
        let selObj = new Object();
        let page = new Object();
        page.pageNum = 0;
        page.pageSize = 4;
        selObj.page = page;
        selObj.sortType = 1;
        selObj.societyId = that.societyId;
        requestByPost(API.selUserDemandPageForHome,JSON.stringify(selObj)).then((res)=>{
          if(res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.obj.userDemandList != null &&  res.data.obj.userDemandList.length != 0){
            that.userDemandList = res.data.obj.userDemandList;
            if(that.userDemandList.length == res.data.obj.page.total){
              that.showMoreDemand = false;
            }else{
              that.showMoreDemand = true;
            }
          }else{
            that.userDemandList = null;
            that.showMoreDemand = false;
          }
        })
      },
       fnShowDemand(){
        if (this.userInfo && this.userInfo.id) {
          //校验该客户拥有的企业有没有所属这个机构的，有就进去，没有则提示
          var list = this.userInfo.ccUserBoList;//公司list
          if (list == null || list.length == 0) {
            Toast("非企业用户，不能发布供应")
          }else {
            let companyList = []
            list.forEach(val =>{
              let societyIdList = val.societyIdList;
              if(societyIdList != null && societyIdList.length > 0 && societyIdList.indexOf(this.societyId) > -1){
                companyList.push(val)
              }
            })
            // setTimeout(() => {

              if(companyList.length == 0){
                Toast("非该协会内企业用户，不能在该协会首页发布供应")
              }else{
                this.$refs.supplyDemandAddForm.showForm(this.userInfo,null,this.societyId)
              }
            // }, 1000);

          }
        } else {
          this.$refs.quoLoginModule.showLogin()
        }
      },
      handleLognSucccessDemand (userInfo) {
        this.$refs.Header.fnSetUserInfo(userInfo)
        this.userInfo = userInfo
        this.fnShowDemand()
      },
      handleDemandSuccess () {
        this.fnSupplyDemand()
      },
      fnSupplyDemand () {
        let that = this;
        let selObj = new Object();
        let page = new Object();
        page.pageNum = 0;
        page.pageSize = 4;
        selObj.page = page;
        selObj.sortType = 1;
        selObj.societyId = that.societyId;
        requestByPost(API.selSupplyDemandShowPage,JSON.stringify(selObj)).then((res) => {
          if (res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.obj.supplyDemandList != null && res.data.obj.supplyDemandList.length != 0) {
            that.supplyDemandList = res.data.obj.supplyDemandList;
            console.log(that.supplyDemandList)
            if (that.supplyDemandList.length == res.data.obj.page.total) {
              that.showMoreSupplyDemand = false;
            }
          }else{
            that.supplyDemandList = null;
            that.showMoreSupplyDemand = false;
          }
        })
      },
      /* 加载更多文章资讯数据*/
	  /* 加载文章资讯list */
	  fnLoadNewsList(selType){
	    let that = this;
	    let selObj = new Object();
	    let page = new Object();
	    page.pageNum = 0;
        if (selType != null && selType != undefined && selType == 2) {
          page.pageSize = 12;
        } else {
          page.pageSize = that.pageSizeSel;
        }
	    selObj.page = page;
	    selObj.societyId = that.societyId;
		// selType;//查询数据类型  0或null：文章资讯列表查询     1：协会主页查询协会动态     2：协会主页查询党建文章
		selObj.selType = selType;
	    requestByPost(API.selSocietyArticleNewsPage,JSON.stringify(selObj)).then((res)=>{
			if(selType == 1){
			  that.fnAddDataToXhdd(res)
			}else{
			  that.fnAddDataToDjzx(res)
			}

	    })
	  },
	  //协会动态文章资讯数据拼装
      fnAddDataToXhdd (res) {
		let that = this
		if(res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.otherList != null &&  res.data.otherList.length != 0){
			that.societyArticleNewsList = res.data.otherList;
			that.societyArticleNewsList.forEach(function (item,index) {
				if (index < 2) {
					that.societyArticleNewsListOne[that.societyArticleNewsListOne.length] = item
				}else{
					that.societyArticleNewsListTwo[that.societyArticleNewsListTwo.length] = item
				}
			})
			if(that.societyArticleNewsList.length == res.data.obj.page.total){
			  that.showMoreNews = false;
			}else{
			  that.showMoreNews = true;
			}
		}else{
			that.societyArticleNewsList = null;
			that.societyArticleNewsListOne = [];
			that.societyArticleNewsListTwo = [];
			that.showMoreNews = false;
		}
	  },
	  //党建中心文章资讯数据拼装
	  fnAddDataToDjzx (res) {
		let that = this
		if(res.data != undefined && res.data.obj != undefined && res.data.obj != null && res.data.otherList != null &&  res.data.otherList.length != 0){
			that.djNewsList = res.data.otherList;
			that.djNewsList.forEach(function (item,index) {
				if (index >= 1) {
					that.djNewsListTwo[that.djNewsListTwo.length] = item
				}
			})
			if(that.djNewsList.length == res.data.obj.page.total){
			  that.showMoreDjNews = false;
			}else{
			  that.showMoreDjNews = true;
			}
		}else{
			that.djNewsList = null;
			that.djNewsListTwo = [];
			that.showMoreDjNews = false;
		}
	  },
	  fnGetDjywText(val){
		  var arr = val.split("<p>");
		  if(arr != null && arr != undefined && arr.length > 0){
			  var valOne = arr[1];
			  if(valOne.indexOf(">") > -1){
				  valOne = valOne.split(">")[1];
			  }
			  var valTwo = valOne.split("</p>")[0];
			  return valTwo;
		  }else{
			  return '[无文本]';
		  }
	  },
      //跳转到企业发布信息详情页
      // fnGotoCompanyDetail(id,e){
      //   this.fnStopBub(e);
      //   this.$router.push({path: '/companyDetailNew', query: {companyId:id,societyId:this.societyId,societyName:this.societyName,logoImgUrl:this.logoImgUrl,inType:2}});
      // },
    //跳转到企业发布信息详情页
      fnGotoCompanyDetail(companyInfo,e){
        this.fnStopBub(e);
        this.$store.commit('home/setSelInputType', 0);
        // if(this.societyId != null && this.societyId != undefined && this.societyId != ''){
        this.$router.push({path: '/companyDetailNew', query: {companyId:companyInfo.companyId,societyId:this.societyId,societyName:this.societyName,logoImgUrl:this.logoImgUrl,inType:1}});
        // }else{
        //   this.$router.push({path: '/companyDetailNew', query: {companyId:companyInfo.id,inType:1}});
        // }
      },
     //跳转到找合作  搜索页直接查 2企业  、  1 产品
      fnGotoSearchPage(selType,e){
        this.fnStopBub(e);
        this.$router.push({path: '/search', query: {selType:selType,societyId:this.societyId}});
      },
      //跳转到文章资讯list
      fnGotoNewsListPage(e,selType){
        this.fnStopBub(e);
        this.$router.push({path: '/societyArticleNews', query: {societyId:this.societyId,societyName:this.societyInfo.societyName,selType: selType}});
      },
      //跳转到文章资讯详情
      fnGotoNewsDetailPage(e,id){
        this.fnStopBub(e);
        // this.$store.commit('home/setCommonTopName', this.societyName);
        // this.$router.push({path: '/force', query: {societyId:this.societyId,id:id,societyName:this.societyInfo.societyName}});
        this.$router.push({path: '/societyArticleNewsDetail', query: {societyId:this.societyId,id:id,societyName:this.societyInfo.societyName}});
      },
     // 跳转页面-用户中心  发布需求
     fnGoToPageUcDemand(e){
		this.fnStopBub(e);
		// this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'demand',state:'preweb'})
		this.$refs.demandAddForm.showForm(null,this.societyId)
     },
	 fnGoToMyDemand () {
	   this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'demand',state:''})
	 },
      fnGotoGxxxPage(e, selType){
        this.fnStopBub(e);
        this.$router.push({path: '/demand', query: {societyId:this.societyId,selType: selType,societyName: this.societyName}});
      },
       handleSupplyDemandClicked (e, supplyDemand) {
        this.fnStopBub(e);
        // Toast("敬请期待");
        if (supplyDemand.linkType == 0) {
          this.$router.push({path: '/companyDetailNew', query: {societyId:this.societyId,societyName: this.societyName,companyId: supplyDemand.companyId,inType:0}});
        } else if (supplyDemand.linkType == 1) {
          this.$router.push({path: '/caseDetail', query: {projectId: supplyDemand.projectId,inType:0}});
        } else if (supplyDemand.linkType == 2) {
          window.open(supplyDemand.linkStr)
        } else {
          return
        }
      },

      //机构主页轮播图，选中index值
      gotoPage(index,e) {
        this.fnStopBub(e);
        this.currentIndex = index;
      },

	  handleSaveDemandSuccess () {
	    this.fnLoadUserDemandList()
	  },
      handleLognSucccess (userInfo) {
        this.userInfo = userInfo
        this.$refs.Header.fnSetUserInfo(userInfo)
      },
       //分辨率控制公司名称字体大小
      fnGetFontSizeNum(companyName){
         // 分辨率控制字体大小
        if(window.screen.width <= 1367 && companyName.length > 17){
          return  "font-size: 18px;";
        }
        return "font-size: 21px;";
      },
      fnGotoDemandDetailPage (e, userDemand) {
        this.fnStopBub(e);
        this.$router.push({path: '/demandDetail', query: {demandId: userDemand.id,inType:2}});
      },
      //分辨率控制公司关键字显示数量
      fnGetShowLeyWordArr(keywordValueArr){
        let showArr = [];
        if(window.screen.width <= 1367){
          if(keywordValueArr != null && keywordValueArr.length > 0){
            if(keywordValueArr.length > 2){
              let num = 0;
              $(keywordValueArr).each(function(index,keyword){
                num += keyword.length;
                if(index == 0){
                  showArr[showArr.length] = keyword;
                }else if(index == 1){
                  if(num < 16){
                      showArr[showArr.length] = keyword;
                  }
                }else if(index == 2){
                  if(num < 20){
                      showArr[showArr.length] = keyword;
                  }
                }
              });
            }else if(keywordValueArr.length <= 2){
              showArr = keywordValueArr;
            }
          }
          return  showArr;
        }else if(window.screen.width <= 1600){
          if(keywordValueArr != null && keywordValueArr.length > 0){
            if(keywordValueArr.length > 2){
              let num = 0;
              $(keywordValueArr).each(function(index,keyword){
                num += keyword.length;
                if(index == 0){
                  showArr[showArr.length] = keyword;
                }else if(index == 1){
                  showArr[showArr.length] = keyword;
                }else if(index == 2){
                  if(num < 22){
                      showArr[showArr.length] = keyword;
                  }
                }
              });
            }else if(keywordValueArr.length <= 2){
              showArr = keywordValueArr;
            }
            return  showArr;
          }
        }else if(window.screen.width <= 1920){
          if(keywordValueArr != null && keywordValueArr.length > 0){
            if(keywordValueArr.length > 2){
              let num = 0;
              $(keywordValueArr).each(function(index,keyword){
                num += keyword.length;
                if(index == 0){
                  showArr[showArr.length] = keyword;
                }else if(index == 1){
                  showArr[showArr.length] = keyword;
                }else if(index == 2){
                  if(num < 23){
                      showArr[showArr.length] = keyword;
                  }
                }
              });
            }else if(keywordValueArr.length <= 2){
              showArr = keywordValueArr;
            }
            return  showArr;
          }
        }else{
          return keywordValueArr;
        }
      },
      //跳转到特定导航页面
      fnGotoDhPage(param){
        this.$store.dispatch('home/fnGoToPage', param).then(res=>{
          this.showMenuType = 0
          if(res != null && res != "" && res.indexOf("societyArticleNewsList") < 0){
            this.$router.push({ path: res })
          }else if(res != null  && res != ""  &&  res.indexOf("societyArticleNewsList") > -1){
              this.fnGotoSearchPage(2);
          }else{
            Toast("敬请期待")
          }
        })
      },
      // 会内职务图标
      fnSoceityPostImg(soceityPost){
        return "../../assets/images/site/"+soceityPost+".png"
      },
	  //分辨率控制文章资讯名显示字数  -- 图文2行
	  fnShowTitleByFbl(titleStr){
	  		if(window.screen.width <= 1367){
	  		  let num = titleStr.length;
	  		  if(num <= 37){
	  		  	return titleStr;
	  		  }else{
	  			return titleStr.substring(0,35)+"...";
	  		  }
	  		}else if(window.screen.width <= 1600){
	  			let num = titleStr.length;
	  			if(num <= 44){
	  				return titleStr;
	  			}else{
	  				return titleStr.substring(0,43)+"...";
	  			}
	  		}else if(window.screen.width <= 1920){
	  			let num = titleStr.length;
	  			if(num <= 47){
	  				return titleStr;
	  			}else{
	  				return titleStr.substring(0,45)+"...";
	  			}
	  		}else{
	  			return titleStr;
	  		}
	  },
	  //分辨率控制文章资讯名显示字数  -- 列表1行
	  fnShowTitleByFblTwo(titleStr){
	  		if(window.screen.width <= 1367){
	  		  let num = titleStr.length;
	  		  if(num <= 37){
	  		  	return titleStr;
	  		  }else{
	  			return titleStr.substring(0,37)+"...";
	  		  }
	  		}else if(window.screen.width <= 1600){
	  			let num = titleStr.length;
	  			if(num <= 44){
	  				return titleStr;
	  			}else{
	  				return titleStr.substring(0,44)+"...";
	  			}
	  		}else if(window.screen.width <= 1920){
	  			let num = titleStr.length;
	  			if(num <= 47){
	  				return titleStr;
	  			}else{
	  				return titleStr.substring(0,47)+"...";
	  			}
	  		}else{
	  			return titleStr;
	  		}
	  }
  },
  mounted() {
    document.title = "觅圈圈";
    $$(document).scroll(function(){
      var y = $$(document).scrollTop()
      console.log()
      if(y >= 100){
          $(".newindextop").addClass("newindextop1").css({"top":0})
      }else{
         $(".newindextop").removeClass("newindextop1").css({"top":"inherit"})
      }
    })
    this.goto()
  },
  created() {
		let that = this;
		// let logoImgUrl = (this.$route.query.logoImgUrl != undefined && this.$route.query.logoImgUrl != null && this.$route.query.logoImgUrl != '' ) ? this.$route.query.logoImgUrl : this.$store.getters['home/getSocietyLogoUrl'];
		// that.$store.commit('home/setMenuStyle', 5);//为了显示灰色头部背景
		that.$store.commit('home/setShowMenuType', 1);//机构菜单
		that.$store.commit('home/setSocietyLogoUrl', that.logoImgUrl);
		that.$store.commit('home/setMenuJgActive', 0);//机构菜单选中哪个
		//初始化机构主信息
		that.fnInitData();
		//初始化企业list
		that.fnLoadCompanyInfoList(1);
		//初始化方案list
		// that.fnLoadReleaseProdCase(1);
		//初始化客户需求列表
		that.fnLoadUserDemandList();
		//初始化机构文章资讯list
		that.fnLoadNewsList(1);
		//初始化党建机构文章资讯list
		that.fnLoadNewsList(2);
		//初始化服务商list
		that.fnSupplyDemand();
  },

  updated(){
    //每个16:9的图片加载完重新算高度
    // $$(".autoHeight").each(function(){
    //   let widthNum = $$(this).width();
    //   $$(this).height(widthNum*9/16);
    // });
    //每个16:7.52的图片(企业封面)加载完重新算高度
    // $$(".autoCompanyImgHeight").each(function(){
    //   let widthNum = $$(this).width();
    //   $$(this).height(widthNum*7.52/16);
    // });
	//每个16:6.8的图片加载完重新算高度
	 $$(".autoHeight").each(function(){
	   let widthNum = $$(this).width();
	   $$(this).height(widthNum*460/1080);
	 });
	 //修改协会动态最后边列表的li的高度
	 let heightNum = $$("ul.autoUlHeight li.autoLiHeight:first").height();
	 $$("ul.autoUlHeight li.autoLiHeight:last").height((heightNum-30)+"px");
  }

};



// WEBPACK FOOTER //
// ./src/pages/society/societyIndex.vue